import { WithdrawFormData } from './types';
import {
    validateCardNumber,
    validateName,
    validateIBAN,
    validateSWIFT,
    validatePostcode,
    validateAmount,
    validateAddress,
    validateCity,
    validateBusinessName,
    validateRequired
} from './validations';

export const validateForm = (formData: WithdrawFormData): boolean => {
    // Check amount first (common for all)
    if (!validateAmount(formData.amount).isValid) {
        return false;
    }

    // Business validation
    if (formData.withdrawType === 'business') {
        return (
            validateIBAN(formData.businessIbanAccountNumber).isValid &&
            validateSWIFT(formData.businessSwiftBic).isValid &&
            validateBusinessName(formData.businessName).isValid &&
            validateRequired(formData.businessCountry).isValid &&
            validateCity(formData.businessTownCity).isValid &&
            validatePostcode(formData.businessPostcode).isValid &&
            validateAddress(formData.businessAddress).isValid
        );
    }

    // Individual - Card validation
    if (formData.withdrawalMethod === 'card') {
        return (
            validateCardNumber(formData.cardNumber).isValid &&
            validateName(formData.nameOnCard).isValid
        );
    }

    // Individual - Bank validation
    return (
        validateName(formData.firstName).isValid &&
        validateName(formData.lastName).isValid &&
        validateIBAN(formData.ibanAccountNumber).isValid &&
        validateSWIFT(formData.swiftBic).isValid &&
        validateRequired(formData.recipientCountry).isValid &&
        validateCity(formData.townCity).isValid &&
        validatePostcode(formData.postcode).isValid &&
        validateAddress(formData.recipientAddress).isValid
    );
};

// Get specific validation error for a field
export const getFieldError = (field: keyof WithdrawFormData, value: string, formData: WithdrawFormData): string | undefined => {
    switch (field) {
        case 'cardNumber':
            return validateCardNumber(value).error;
        case 'nameOnCard':
        case 'firstName':
        case 'lastName':
            return validateName(value).error;
        case 'ibanAccountNumber':
        case 'businessIbanAccountNumber':
            return validateIBAN(value).error;
        case 'swiftBic':
        case 'businessSwiftBic':
            return validateSWIFT(value).error;
        case 'postcode':
        case 'businessPostcode':
            return validatePostcode(value).error;
        case 'amount':
            return validateAmount(value).error;
        case 'recipientAddress':
        case 'businessAddress':
            return validateAddress(value).error;
        case 'townCity':
        case 'businessTownCity':
            return validateCity(value).error;
        case 'businessName':
            return validateBusinessName(value).error;
        case 'recipientCountry':
        case 'businessCountry':
        case 'currency':
            return validateRequired(value).error;
        default:
            return undefined;
    }
};